import { boot } from 'quasar/wrappers'

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[]
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  }>
  prompt (): Promise<void>
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent
  }
}

export default boot(async ({ store }) => {
  window.addEventListener('beforeinstallprompt', async e => {
    store.commit('pwa/SET_FN', () => e.prompt())
    try {
      const { outcome } = await e.userChoice
      outcome === 'accepted' && store.commit('pwa/SET_FN', false)
    } catch (error) {
      console.log(error)
    }
  })
})
